import React from "react";
import {
  Card,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import {
  spacing,
  colors,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import CVRChart from "./CVRChart";

interface CVRChartWrapProps {
  dateType: string;
  endDate: string;
  setTimeUnit: React.Dispatch<React.SetStateAction<string>>;
  startDate: string;
  timeUnit: string;
}

const CVRChartWrap = ({
  dateType,
  endDate,
  setTimeUnit,
  startDate,
  timeUnit,
}: CVRChartWrapProps) => {
  const handleChange = (value: any) => {
    setTimeUnit(value);
  };

  return (
    <Card
      sx={{
        borderRadius: spacing.Radius.md.$value,
        boxShadow: 3,
        mb: spacing.Spacing.xl.$value,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
        sx={{
          px: spacing.Spacing.xl.$value,
          pt: spacing.Spacing.xl.$value,
          pb: spacing.Spacing.none.$value,
        }}
      >
        <Typography
          color={colors.GrayLightMode[700].$value}
          sx={{
            fontSize: typography.Size.Text.sm.$value,
            lineHeight: typography.Line_height.text.sm.$value,
            fontWeight: typography.Font_weight.Medium.$value,
          }}
        >
          Conversion Rate over time
        </Typography>

        <FormControl size="small">
          <Select
            value={timeUnit}
            onChange={(e) => handleChange(e.target.value)}
            MenuProps={{
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    fontSize: typography.Size.Text.sm.$value,
                    minHeight: spacing.Spacing["5xl"].$value,
                  },
                },
              },
            }}
            sx={{
              borderRadius: 2,
              height: spacing.Spacing["4xl"].$value,
              minWidth: spacing.Spacing["9xl"].$value,
              maxWidth: spacing.Spacing["9xl"].$value,
              py: spacing.Spacing.sm.$value,
              px: spacing.Spacing.none.$value,
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
              fontWeight: typography.Font_weight.Medium.$value,
              color: colors.GrayLightMode[700].$value,
            }}
          >
            <MenuItem value="day">Day</MenuItem>
            <MenuItem value="week">Week</MenuItem>
            <MenuItem value="month">Month</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <CVRChart
        dateType={dateType}
        endDate={endDate}
        startDate={startDate}
        timeUnit={timeUnit}
      />
    </Card>
  );
};

export default CVRChartWrap;
